import { API_CREATE_PROFESSIONAL_SOLUTION_SUCCESS, API_GET_ONE_PROFESSIONAL_SOLUTION, API_GET_ONE_PROFESSIONAL_SOLUTION_SUCCESS, CHANGE_STEP_OF_PROFESSIONAL_SOLUTION, INITIALIZE_PROFESSIONAL_SOLUTION, } from '../actions/ProfessionalSolutionActions';
const INITIAL_STATE = { step: 1 };
// eslint-disable-next-line default-param-last
export default (state = INITIAL_STATE, { payload, type }) => {
    switch (type) {
        case INITIALIZE_PROFESSIONAL_SOLUTION: {
            return Object.assign({}, INITIAL_STATE);
        }
        case CHANGE_STEP_OF_PROFESSIONAL_SOLUTION: {
            return Object.assign(Object.assign({}, state), payload);
        }
        case API_GET_ONE_PROFESSIONAL_SOLUTION: {
            return Object.assign(Object.assign({}, state), { detail: {} });
        }
        case API_GET_ONE_PROFESSIONAL_SOLUTION_SUCCESS:
        case API_CREATE_PROFESSIONAL_SOLUTION_SUCCESS: {
            return Object.assign(Object.assign({}, state), { detail: Object.assign({}, payload) });
        }
        default: {
            return state;
        }
    }
};
